import React from 'react';

const HubComparison = () => (
  <section data-testid="hub-comparison" className="py-24 border-t border-white/10">
    <div className="max-w-6xl mx-auto px-6">
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4 text-center">Perché AI_COVO?</p>
      <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-16 text-center">
        Un ecosistema,<br />
        <span className="text-[#00FF41]">la Hub sociale che mancava.</span>
      </h2>
      
      <div className="grid md:grid-cols-2 gap-8">
        <div className="bg-zinc-900/50 border border-white/5 p-8">
          <h3 className="text-xl font-bold text-white mb-6">Coworking Tradizionale</h3>
          <ul className="space-y-4 text-white font-bold">
            <li className="flex items-center gap-3"><span className="text-zinc-600">—</span>Scrivanie condivise</li>
            <li className="flex items-center gap-3"><span className="text-zinc-600">—</span>Solo riduzione costi</li>
            <li className="flex items-center gap-3"><span className="text-zinc-600">—</span>Spazio fisico</li>
            <li className="flex items-center gap-3"><span className="text-zinc-600">—</span>Lavoro individuale</li>
          </ul>
        </div>
        
        <div className="bg-[#00FF41]/5 border border-[#00FF41]/30 p-8 neon-border">
          <h3 className="text-xl font-bold text-[#00FF41] mb-6">AI_COVO · Hub Sociale</h3>
          <ul className="space-y-4 text-white">
            <li className="flex items-center gap-3"><span className="text-[#00FF41]">✓</span>Ecosistema completo</li>
            <li className="flex items-center gap-3"><span className="text-[#00FF41]">✓</span>Collaborazione strutturata</li>
            <li className="flex items-center gap-3"><span className="text-[#00FF41]">✓</span>Innovazione + Tecnologia</li>
            <li className="flex items-center gap-3"><span className="text-[#00FF41]">✓</span>Networking + Community</li>
            <li className="flex items-center gap-3"><span className="text-[#00FF41]">✓</span>Well-being integrato</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default HubComparison;
